const pl = {
  questionPaperLibrary: "Biblioteka arkuszy pytan",
  questionPaperLibraryDescription:
    "Twoja dynamiczna przestrzen robocza do tworzenia pojedynczych pytan i projektowania kompleksowych arkuszy pytan.",
  assessmentLibrary: "Biblioteka ocen",
  assessmentLibraryDescription:
    "Zarzadzaj harmonogramami, zapraszaj uczestnikow i monitoruj raporty wydajnosci w jednym centralnym miejscu.",
  myAssessmentWidgetTitle: "Moja ocena",
  myPreferences: "Moje preferencje",
  assessmentsForYou: "Oceny dla Ciebie",
  exploreAssessmentsAssignedToYou: "Przegladaj oceny przypisane do Ciebie",
  hitachiAcademy: "Akademia Hitachi",
  essentialBusinessKnowledgeTestForYou:
    "Niezbedny test wiedzy biznesowej dla Ciebie",
  continuousLearningJourneyDescription:
    "Zaprojektowano, aby pomóc Ci zrozumieć i wzmocnić umiejętności biznesowe podczas ciągłej nauki",
  noActiveAssessmentsScheduledForYou:
    "Brak aktywnych ocen zaplanowanych dla Ciebie",
  upcoming: "Nadchodzace",
  notAttempted: "Nie podjeto proby",
  myAssessmentCardDescription:
    "Ta ocena sprawdza Twoje umiejetnosci techniczne, analityczne i rozwiazywania problemow w ramach procesu rekrutacji kampusowej GlobalLogic.",
  totalDuration: "Calkowity czas trwania",
  startTime: "Godzina rozpoczecia",
  questionAuthoring: "Tworzenie pytan",
  reviewQuestions: "Przejrzyj pytania",
  bulkUploadHistory: "Historia przesylan zbiorczych",
  bulkActionHistory: "Historia dzialan zbiorczych",
  editQuestion: "Edytuj pytanie",
  inviteParticipants: "Zaproś uczestnikow",
  externalUserBulkUploadHistory:
    "Historia zbiorczego przesylania uzytkownikow zewnetrznych",
  assessmentSchedule: "Harmonogram oceny",
  assessmentReport: "Raport oceny",
  bulkHistory: "Historia zbiorcza",
  myUpload: "Moje przesylanie",
  bulkUpload: "Przesylanie zbiorcze",
  createQuestion: "Utworz pytanie",
  bulkUploadQuestions: "Zbiorcze przesylanie pytan",
  filters: "Filtry",
  clear: "Wyczysc",
  searchByTitle: "Szukaj po tytule",
  refresh: "Odswiez",
  refreshing: "Odswiezanie",
  reviewQuestionPapers: "Przegladaj arkusze pytan",
  myQuestionPapers: "Moje arkusze pytan",
  viewQuestionBank: "Zobacz bank pytan",
  createNew: "Utworz nowy",
  sortBy: "Sortuj wedlug",
  state: "Stan",
  reviewed: "Sprawdzone",
  reviewedTooltip:
    "Pokaz arkusze pytan, ktore zostaly sprawdzone i nastepnie opublikowane.",
  all: "Wszystkie",
  draft: "Wersja robocza",
  published: "Opublikowane",
  inReview: "W trakcie przegladu",
  sentBack: "Odeslane",
  readyToPublish: "Gotowe do publikacji",
  draftDescription:
    "Tworzenie arkusza pytan jest nadal w toku i nie jest jeszcze dostepne dla uczestnikow",
  publishedDescription:
    "Arkusz pytan jest opublikowany i dostepny dla uczestnikow",
  inReviewDescription:
    "Arkusz pytan jest w trakcie przegladu i nie zostal jeszcze zatwierdzony",
  sentBackDescription: "Arkusz pytan zostal odeslany do poprawek",
  readyToPublishDescription: "Arkusz pytan jest gotowy do publikacji",
  createdAt: "Utworzono",
  updatedAt: "Zaktualizowano",
  publishedAt: "Opublikowano",
  descending: "Malejaco",
  ascending: "Rosnaco",
  success: "Sukces",
  error: "Błąd",
  warning: "Ostrzeżenie",
  info: "Informacja",
  yes: "Tak",
  no: "Nie",
  noMatchingContentFound: "Nie znaleziono pasujacej tresci",
  noQuestionPapersAvailableForReview: "Brak arkuszy pytan do przegladu",
  questionPaperNotYetCreated: "Arkusz pytan nie zostal jeszcze utworzony",
  createQuestionPaperDescription:
    "Utworz arkusz pytan, aby ocenic umiejetnosci i wiedze uczestnikow",
  createYourFirstQuestionPaper: "Utworz swoj pierwszy arkusz pytan",
  createQuestionPaperModalTitle: "Utworz arkusz pytan",
  questionsTab: "Pytania",
  questionPaperSettingsTab: "Ustawienia arkusza pytań",
  editQuestionPaper: "Edytuj arkusz pytań",
  save: "Zapisz",
  publish: "Publikować",
  sendForReview: "Wyślij do sprawdzenia",
  sendingForReview: "Wysyłam do przeglądu",
  publishing: "Wydawniczy",
  clone: "Klon",
  delete: "Usuwać",
  view: "Pogląd",
  edit: "Redagować",
  close: "Zamknąć",
  create: "Tworzyć",
  creating: "Tworzenie",
  confirm: "Potwierdzać",
  cancel: "Anulować",
  version: "Wersja",
  untitled: "Bez tytułu",
  noVersion: "Brak wersji",
  title: "Tytuł",
  status: "Status",
  action: "Działanie",
  createdBy: "Stworzony przez",
  createNewVersion: "+ Nowa wersja",
  createNewVersionTitle: "Utwórz nową wersję",
  deleteQuestionPaperPrompt: "Czy na pewno chcesz usunąć tę kartę pytań?",
  deleteQuestionPaperWithTitlePrompt:
    "Czy chcesz usunąć ten arkusz pytań zatytułowany „{{title}}”?",
  cloneQuestionPaperPrompt: "Czy chcesz sklonować ten arkusz pytań?",
  publishQuestionPaperPrompt:
    "Czy na pewno chcesz opublikować ten arkusz pytań?",
  sendForReviewQuestionPaperPrompt:
    "Czy na pewno chcesz wysłać ten arkusz pytań do sprawdzenia?",
  successfullyDeletedQuestionPaper: "Pomyślnie usunięto arkusz pytań",
  successfullyMovedQuestionPaperToDraft:
    "Pomyślnie przeniesiono arkusz pytań do wersji roboczej",
  successfullySavedQuestionPaperData: "Pomyślnie zapisano dane arkusza pytań",
  successfullyClonedQuestionPaper: "Pomyślnie sklonowano arkusz pytań",
  successfullyCreatedQuestionPaper: "Pomyślnie utworzono arkusz pytań",
  validationFailedWithFollowingErrors:
    "Walidacja nie powiodła się z powodu następujących błędów:",
  failedStatusUpdateOf: "Nieudana aktualizacja statusu:",
  savedWithFollowingWarnings: "Zapisano z następującymi ostrzeżeniami:",
  reviewedAndPublished: "Zrecenzowane i opublikowane",
  deleting: "Usuwanie...",
  cloning: "Klonowanie...",
  assessment: "Ocena",
  public: "Publiczny",
  private: "Prywatny",
  visibility: "Widoczność",
  questionType: "Typ pytania",
  selectQuestionTypeAndVisibility: "Wybierz Typ pytania i widoczność",
  singleChoice: "Pojedynczy wybór",
  multipleChoice: "Wielokrotny wybór",
  trueOrFalse: "Prawda czy fałsz",
  fillInTheBlanks: "Wypełnij puste miejsca",
  codingQuestion: "Pytanie dotyczące kodowania",
  subjectiveQuestion: "Subiektywne pytanie",
  speakingQuestion: "Pytanie mówiące",
  downloadTemplateEditAndReuploadQuestions:
    "Pobierz szablon, edytuj i prześlij ponownie listę pytań",
  downloadExcelTemplateInstruction:
    "Pobierz szablon Excel za pomocą przycisku poniżej.",
  addQuestionsToSheetInstruction:
    "Dodaj swoje pytania do arkusza (instrukcje znajdują się w środku).",
  uploadCompletedExcelInstruction:
    "Prześlij wypełniony plik Excel, aby zbiorczo zaimportować pytania.",
  uploading: "Przesyłanie...",
  uploadQuestions: "Prześlij pytania",
  completed: "Zakończony",
  invalid: "Nieważny",
  initiated: "Zapoczątkowany",
  failed: "Przegrany",
  fileName: "Nazwa pliku",
  templateType: "Typ szablonu",
  uploadedAt: "Przesłano o godz",
  actions: "Działania",
  mcqTemplate: "Szablon MCQ",
  fibTemplate: "Szablon FIB",
  monitorUploadExcelDescription:
    "Monitoruj każdy przesyłany plik Excel, sprawdzaj, ile pytań zostało dodanych lub nie udało się, i w razie potrzeby wyświetl szczegóły błędu.",
  reset: "Resetuj",
  showing: "Wyświetlanie",
  to: "Do",
  of: "z",
  results: "wyniki",
  noExcelFound: "Nie znaleziono Excela",
  cloneAssessmentConfirmation: "Potwierdzenie oceny klonowania",
  cloneAssessmentWithTitlePrompt:
    "Czy na pewno chcesz sklonować tę ocenę zatytułowaną „{{title}}”?",
  successfullyClonedAssessment: "Ocena została pomyślnie sklonowana",
  newVersionContentPrompt:
    "Zamierzasz utworzyć nową wersję tej zawartości. Wszelkie dalsze zmiany zostaną zapisane w tej wersji. Czy chcesz kontynuować?",
  createVersionWithNumber: "Utwórz (V{{version}})",
  addYourComment: "Dodaj swój komentarz",
  maxLimitReached: "osiągnięto maksymalny limit",
  deleteContentPrompt: "Czy na pewno chcesz usunąć ten {{contentType}}?",
  deleteContentWithTitlePrompt:
    "Czy na pewno chcesz usunąć ten {{contentType}} zatytułowany „{{title}}”?",
  schedulePreview: "Podgląd harmonogramu",
  reschedule: "Zmień termin",
  cancelled: "Odwołany",
  copyLink: "Skopiuj link",
  assessmentIsCancelled: "Ocena zostaje anulowana",
  deleteConfirmation: "Usuń potwierdzenie",
  cancelConfirmation: "Anuluj potwierdzenie",
  deleteAssessmentPrompt: "Czy na pewno chcesz usunąć tę ocenę?",
  cancelAssessmentPrompt: "Czy na pewno chcesz anulować tę ocenę?",
  rescheduleAssessment: "Przełóż ocenę",
  customTermsAndConditions: "Niestandardowe warunki",
  viewTermsAndConditions: "Zobacz Regulamin",
  scheduleNewAssessment: "Zaplanuj nową ocenę",
  selectQuestionPaper: "Wybierz opcję Arkusz pytań",
  createAssessment: "Utwórz ocenę",
  failedToLoadData: "Nie udało się załadować danych!",
  assessmentNotYetCreated: "Ocena nie została jeszcze utworzona",
  createAssessmentDescription:
    "Utwórz ocenę, aby ocenić umiejętności i wiedzę uczniów",
  createYourFirstAssessment: "Utwórz swoją pierwszą ocenę",
  failedToLoadSchedules: "Nie udało się załadować harmonogramów",
  errors: "Błędy:",
  basicInformation: "Podstawowe informacje",
  assessmentName: "Nazwa oceny",
  na: "NA",
  scheduleInstructions: "Instrukcje dotyczące harmonogramu",
  noInstructionsProvided: "Brak instrukcji",
  accessCriteria: "Kryteria dostępu",
  searchTags: "Szukaj tagów",
  viewAttributes: "Wyświetl atrybuty",
  termsAndConditions: "Regulamin",
  enabled: "Włączony",
  disabled: "Wyłączony",
  requireCandidatesToAcceptTerms:
    "Wymagaj od kandydatów zaakceptowania Regulaminu przed rozpoczęciem oceny",
  proctoringSettings: "Ustawienia nadzoru",
  enableVideoProctoring: "Włącz ochronę wideo",
  maximumVideoViolationsAllowed:
    "Maksymalna dozwolona liczba naruszeń dotyczących filmów",
  enableBrowserProctoring: "Włącz ochronę przeglądarki",
  maximumBrowserViolationsAllowed:
    "Maksymalna dozwolona liczba naruszeń przeglądarki",
  displayViolationsToCandidates: "Wyświetlaj naruszenia kandydatom",
  actionWhenViolationLimitReached: "Działanie po osiągnięciu limitu naruszenia",
  flagged: "Oflagowany",
  terminate: "Zamknij",
  stakeholdersAndFeedback: "Interesariusze i informacje zwrotne",
  owner: "Właściciel",
  recruiter: "Rekruter",
  allowCandidateFeedback: "Zezwalaj na opinie kandydatów",
  enableCandidateFeedbackDescription:
    "Umożliwiaj kandydatom przesyłanie informacji zwrotnych po ukończeniu oceny",
  schedulingAndTimerSettings: "Ustawienia harmonogramu i timera",
  scheduleType: "Typ harmonogramu",
  loginWindow: "Okno logowania",
  durationBased: "Na podstawie czasu trwania",
  deadline: "Termin ostateczny",
  autoCompleteMode: "Tryb automatycznego uzupełniania",
  startDateAndTime: "Data i godzina rozpoczęcia",
  loginWindowInMinutes: "Okno logowania (w minutach)",
  endDateAndTime: "Data i godzina zakończenia",
  timerEnabled: "Timer włączony",
  assessmentRules: "Zasady oceniania",
  assessmentPattern: "Wzór oceny",
  resultVisibility: "Widoczność wyników",
  passPercentage: "Procent zaliczenia",
  maximumAttemptsAllowed: "Maksymalna dozwolona liczba prób",
  unlimitedAttempts: "Nieograniczone próby",
  attempt: "próba",
  attempts: "próbowanie",
  coolOffPeriodBetweenAttempts: "Okres odpoczynku pomiędzy próbami",
  questionDisplaySettings: "Ustawienia wyświetlania pytań",
  showQuestionTitle: "Pokaż tytuł pytania",
  showQuestionTitleDescription: "Wyświetl tytuł pytania nad każdym pytaniem",
  showHint: "Pokaż wskazówkę",
  showHintDescription:
    "Włącz wskazówki, które pomogą kandydatowi podczas oceny",
  showExplanation: "Pokaż wyjaśnienie",
  hintLoading: "Musisz poczekać, zanim zobaczysz kolejną wskazówkę",
  allHintsShown: "Brak oczekujących wskazówek",
  hideExplanation: "Ukryj wyjaśnienie",
  showExplanationDescription: "Pokaż wyjaśnienia po przesłaniu każdego pytania",
  showQuestionMarks: "Pokaż znaki zapytania",
  showQuestionMarksDescription:
    "Wyświetl wartość oceny/punktacji dla każdego pytania",
  showWatermark: "Pokaż znak wodny",
  showWatermarkDescription:
    "Wyświetl adres e-mail kandydata dla każdego pytania jako znak wodny",
  questionPaperPreview: "Podgląd arkusza pytań",
  questionPaperReview: "Przegląd arkusza pytań",
  createSchedule: "Utwórz harmonogram",
  reviewerComments: "Komentarze recenzentów",
  reviewComments: "Przejrzyj komentarze",
  sendBackQuestionPaperPrompt: "Czy na pewno chcesz odesłać tę kartę pytań?",
  moveQuestionPaperToDraftPrompt:
    "Czy na pewno chcesz przenieść ten arkusz pytań do wersji roboczej?",
  markQuestionPaperReadyToPublishPrompt:
    "Czy na pewno chcesz oznaczyć ten arkusz pytań jako gotowy do publikacji?",
  questionPaperStatusUpdatedSuccessfully:
    "Status arkusza pytań został pomyślnie zaktualizowany!",
  newVersionQuestionPaperCreatedSuccessfully:
    "Nowa wersja arkusza pytań została utworzona pomyślnie!",
  questionPaperClonedSuccessfully: "Arkusz pytań został pomyślnie sklonowany!",
  startAddingQuestionsPreview:
    "Zacznij dodawać pytania, aby wyświetlić podgląd tutaj",
  bulkInviteParticipants: "Zbiorcze zaproszenie uczestników",
  bulkInviteParticipantsDescription:
    "Zaproś wielu uczestników jednocześnie, przesyłając wstępnie wypełniony plik Excel. Aby upewnić się, że format jest prawidłowy, skorzystaj z dostarczonego szablonu.",
  maxParticipantsPerFileNote:
    "Maksymalnie 200 uczestników na plik. Zduplikowane lub nieprawidłowe wpisy zostaną pominięte z błędem.",
  downloadTemplate: "Pobierz szablon",
  creatingUser: "Tworzenie użytkownika...",
  bulkInviteLabel: "Zaproszenie zbiorcze",
  createAndInvite: "Twórz i zapraszaj",
  myUploads: "Moje przesłane pliki",
  enterIndividualsForInvite:
    "Wpisz nazwiska jednej lub kilku osób, które chcesz zaprosić do oceny",
  searchPeopleByEmailOrName: "Szukaj osób po adresie e-mail lub nazwisku",
  noResultsFound: "Nie znaleziono wyników",
  loading: "Załadunek..",
  or: "Lub",
  multipleEmailsInviteDescription:
    "Dodaj adresy e-mail wielu użytkowników, oddzielone przecinkami, aby zaprosić wielu użytkowników do oceny",
  addCandidates: "Dodaj kandydatów",
  pleaseEnterValidNameOrEmail:
    "Proszę podać prawidłowe imię i nazwisko lub adres e-mail",
  pleaseEnterValidEmailAddress: "Proszę podać prawidłowy adres e-mail",
  someEmailsCouldNotBeAdded: "Nie udało się dodać niektórych adresów e-mail",
  checkInvalidEmailIds:
    "Sprawdź następujące identyfikatory e-mail – wydają się być nieprawidłowe:",
  failedToSendInvitesFollowingEmails:
    "Nie udało się wysłać zaproszeń na następujące e-maile:",
  successfullyInvitedMembers: "Pomyślnie zaproszono członka {{count}}",
  validationFailed: "Walidacja nie powiodła się",
  excelUploadedSuccessfully: "Excel przesłano pomyślnie",
  invalidBulkNominationTemplate: "Nieprawidłowy szablon nominacji zbiorczej",
  actionCompletedWithWarnings: "Akcja zakończona następującymi ostrzeżeniami:",
  actionFailedWithErrors:
    "Nie można ukończyć akcji i zakończyć ją z powodu następujących błędów:",
  trackBulkOperationsAndResults: "Śledź wszystkie operacje masowe i ich wyniki",
  partiallySaved: "Częściowo zapisane",
  statusInitiatedDescription:
    "Żądanie aktualizacji pytania zostało przesłane i jest przetwarzane.",
  statusCompletedDescription:
    "Wszystkie wybrane pytania zostały pomyślnie zaktualizowane.",
  statusFailedDescription:
    "Żadne z wybranych pytań nie zostało pomyślnie przetworzone.",
  statusPartiallySavedDescription:
    "Niektóre pytania zostały zapisane pomyślnie, podczas gdy inne napotkały problemy.",
  draftReadyToPublishToPublish:
    "Wersja robocza/gotowa do publikacji -> Publikuj",
  actionType: "Typ akcji",
  uploadedOn: "Przesłano dnia",
  viewDetails: "Zobacz szczegóły",
  loadingRecords: "Ładowanie rekordów...",
  noRecordsFound: "Nie znaleziono żadnych rekordów",
  recordsPerPage: "Rekordy na stronę:",
  page: "Strona",
  untitledQuestion: "Pytanie bez tytułu",
  globalLogic: "Globalna logika",
  aiGenerated: "Wygenerowano sztuczną inteligencję",
  fullScreen: "Pełny ekran",
  exitFullScreen: "Wyjdź z pełnego ekranu",
  skills: "Umiejętności",
  tags: "Tagi",
  allowedCodingLanguages: "Dozwolone języki kodowania",
  marks: "Znaki",
  lastUpdatedAt: "Ostatnia aktualizacja o godz",
  solutionCode: "Kod rozwiązania",
  solution: "Rozwiązanie",
  starterCode: "Kod startowy",
  options: "Opcje",
  explanation: "Wyjaśnienie",
  hint: "Wskazówka",
  deleteQuestion: "Usuń pytanie",
  noSections: "Brak dodanych sekcji",
  editAndPublish: "Edytuj i publikuj",
  sendBackToDraftInstruction:
    "Kliknij przycisk Odeślij, aby wysłać pytanie z powrotem do wersji roboczej.",
  updateStatusReadyToPublishInstruction:
    "Kliknij przycisk Gotowe do publikacji, aby zaktualizować status.",
  successfullyUpdatedStatus: "Pomyślnie zaktualizowano status",
  dismiss: "Odrzucać",
  ongoing: "W toku",
  toBeLaunched: "Do uruchomienia",
  contentExpired: "Treść wygasła",
  notApplicable: "Nie dotyczy",
  expiresSoon: "Wygasa wkrótce",
  contentCreationInProgressTooltip:
    "Tworzenie treści nadal trwa i nie jest jeszcze dostępne dla uczniów",
  contentLiveAccessibleTooltip:
    "Treść jest opublikowana i dostępna dla uczniów",
  contentAvailableWithinDatesTooltip:
    "Treść jest obecnie dostępna, ponieważ mieści się w zakresie dat uruchomienia i wygaśnięcia",
  contentNotLaunchedAvailableOnTooltip:
    "Treść nie została jeszcze uruchomiona i będzie dostępna",
  contentExpiredOnTooltip: "Ta treść wygasła",
  statusAvailableAfterPublishTooltip:
    "Status będzie dostępny po opublikowaniu treści",
  contentExpiresWithin48HoursTooltip: "Ta treść wygaśnie w ciągu 48 godzin.",
  moveToDraftOrCloneToEdit:
    "Przenieś do wersji roboczej lub sklonuj, aby wprowadzić zmiany",
  webContent: "Treść internetowa",
  eLearning: "E-learning",
  untitledContent: "Treść bez tytułu",
  sendToDraft: "Przenieś do wersji roboczej",
  sendToDraftPublishedInstruction:
    "Ta treść jest już opublikowana. Aby wprowadzić zmiany, kliknij przycisk Przenieś do wersji roboczej.",
  copyLinkForLearner: "Skopiuj link dla ucznia",
  questionPaperName: "Nazwa arkusza pytań",
  type: "Typ",
  duration: "Czas trwania",
  minutes: "Minuty",
  difficultyLevel: "Poziom trudności",
  language: "Język",
  timezone: "Strefa czasowa",
  preferredLocation: "Preferowana lokalizacja",
  notSelected: "Nie wybrano",
  selectedPreferencesHeading: "Wybrane preferencje",
  selectedPreferencesInfo:
    "Wybrane preferencje dla lepszego komfortu korzystania",
  shortDescription: "Krótki opis",
  totalMarks: "Łączna liczba punktów",
  questionPaperInstructions: "Instrukcje arkusza pytań",
  expiryDate: "Data wygaśnięcia",
  knowledgeCategory: "Kategoria wiedzy",
  category: "Kategoria",
  subCategory: "Podkategoria",
  region: "Region",
  usage: "Zastosowanie",
  internalUseOnly: "Tylko do uzytku wewnetrznego",
  externalUseOnly: "Tylko do uzytku zewnetrznego",
  availableForAll: "Dostepne dla wszystkich",
  apac: "APAC",
  emea: "EMEA",
  latinAmerica: "Ameryka Łacińska",
  northAmerica: "Ameryka Północna",
  globalRegion: "Globalny",
  automotive: "Motoryzacja",
  bankingFinancialServicesInsurance:
    "Bankowość, usługi finansowe i ubezpieczenia",
  connectivitySolutionsCommunication: "Rozwiązania łączności/komunikacji",
  consumerRetail: "Dobra konsumenckie i handel detaliczny",
  healthcareLifeSciences: "Opieka zdrowotna i nauki przyrodnicze",
  manufacturingAndIndustrial: "Produkcja i przemysł",
  mediaEntertainment: "Media i rozrywka",
  technology: "Technologia",
  other: "Inne",
  behavioralInterpersonal: "Behawioralne/interpersonalne",
  technical: "Techniczne",
  processAndTools: "Procesy i narzędzia",
  polishLanguage: "Polski",
  spanishLanguage: "Hiszpański",
  japaneseLanguage: "Japoński",
  germanLanguage: "Niemiecki",
  ukrainianLanguage: "Ukraiński",
  swedishLanguage: "Szwedzki",
  romanianLanguage: "Rumuński",
  slovakLanguage: "Słowacki",
  croatianLanguage: "Chorwacki",
  englishUsLanguage: "Angielski (US)",
  englishUkLanguage: "Angielski (UK)",
  englishInLanguage: "Angielski (IN)",
  netTech: "NET",
  aiMl: "AI/ML",
  automotiveStandardsProtocols: "Standardy i protokoły motoryzacyjne",
  businessAnalysis: "Analiza biznesowa",
  cCpp: "C/C++",
  cloudDataScience: "Chmurowa nauka o danych",
  bigData: "Big Data",
  dataAnalytics: "Analityka danych",
  databaseTech: "Baza danych",
  developmentTools: "Narzędzia programistyczne",
  devops: "DevOps",
  embedded: "Systemy wbudowane",
  javaTech: "Java",
  javaScriptTech: "JavaScript",
  linuxKernel: "Jądro Linux",
  mobileDev: "Rozwój mobilny",
  networking: "Sieci",
  operatingSystemsServers: "Systemy operacyjne i serwery",
  otherTech: "Inne - Tech",
  productivityTools: "Narzędzia produktywności",
  programmingLangOther: "Języki programowania - Inne",
  pythonTech: "Python",
  phpTech: "PHP",
  qaAqa: "QA / AQA",
  softwareEngineering: "Inżynieria oprogramowania",
  uxUi: "UX/UI",
  architectureTech: "Architektura",
  golang: "Golang",
  requirementEngineeringTechnicalWriting:
    "Inżynieria wymagań/Pisanie techniczne",
  onboarding: "Onboarding",
  glTools: "Narzędzia GL",
  processAndPolicies: "Procesy i polityki",
  communicationSubCategory: "Komunikacja",
  personalEffectiveness: "Skuteczność osobista",
  methodologies: "Metodologie",
  projectManagement: "Zarządzanie projektami",
  peopleManagement: "Zarządzanie ludźmi",
  leadershipPrograms: "Programy liderskie",
  domain: "Domena",
  reviewer: "Recenzent",
  none: "Brak",
  questionPaperPreviewBreadcrumb: "Podgląd arkusza pytań: {{title}}",
  questionPaperInReviewContactReviewer:
    "Ten arkusz pytań jest obecnie w recenzji. Skontaktuj się z recenzentem.",
  randomization: "Losowanie",
  randomizationInSectionDescription:
    "Pytania w tej sekcji beda wyswietlane kandydatom w losowej kolejnosci",
  questionPreviewPlaceholderImage: "Symbol zastępczy podglądu pytania",
  createNewVersionPromptWithNumber: "Utworzyć nową wersję (V{{version}})?",
  questionPreviewBreadcrumb: "Podglad pytania: {{title}}",
  questionPreviewTitle: "Podglad pytania",
  adminView: "Widok administratora",
  candidateView: "Widok kandydata",
  viewAsCandidate: "Wyswietl jako kandydat",
  closePanel: "Zamknij panel",
  internalQuestion: "Pytanie wewnetrzne",
  expiresOn: "Wygasa",
  expiredLabel: "Wygaslo",
  solutionNotAdded: "Nie dodano rozwiazania",
  testCases: "Przypadki testowe",
  testCasesNotAdded: "Nie dodano przypadkow testowych",
  starterCodeNotAdded: "Nie dodano kodu startowego",
  groupTitleLengthValidation:
    "Tytul grupy musi miec wiecej niz 5 i mniej niz 120 znakow",
  addTitleHere: "Dodaj tytul tutaj...",
  groupUpdatedSuccessfully: "Grupa zostala pomyslnie zaktualizowana",
  groupDeletedSuccessfully: "Grupa zostala pomyslnie usunieta",
  group: "Grupa",
  numberOfQuestionsToBeShown: "Liczba pytan do wyswietlenia",
  questionLimitPerSectionDescription:
    "Pokaz kandydatom tylko okreslona liczbe pytan w sekcjach",
  numberOfQuestionsToShow: "Liczba pytan do wyswietlenia {{picked}}/{{total}}",
  collapseGroup: "Zwin grupe",
  expandGroup: "Rozwin grupe",
  groupSetupStartAddingQuestions:
    "Dla tej sekcji skonfigurowano grupe. Zacznij dodawac do niej pytania.",
  addMoreQuestions: "Dodaj wiecej pytan",
  addQuestionFromLibrary: "Dodaj pytanie z biblioteki",
  questionDeletedSuccessfully: "Pytanie zostalo pomyslnie usuniete",
  questionsShownCountUpdated:
    "Liczba wyswietlanych pytan zostala zaktualizowana",
  failedToDeleteQuestion: "Nie udalo sie usunac pytania",
  caseSensitive: "Rozroznia wielkosc liter",
  caseSensitiveDescription:
    "Jesli wlaczone, uczestnicy musza wpisac odpowiedz z dokladnie taka sama wielkoscia liter.",
  enterYourAnswerBelow: "Wpisz swoja odpowiedz ponizej",
  caseSensitiveAnswerInfo:
    "To pytanie rozroznia wielkosc liter, dlatego wpisz odpowiedzi z dokladnie taka sama wielkoscia liter.",
  answerWithNumber: "Odpowiedz {{number}}",
  inviteEmailsPlaceholder:
    "użytkownik1@globallogic.com, użytkownik2@globalllogic.com",
  visibleTestCases: "Widoczne przypadki testowe",
  hiddenTestCases: "Ukryte przypadki testowe",
  visibleLabel: "Widoczne",
  hiddenLabel: "Ukryte",
  responseSetting: "Ustawienia odpowiedzi",
  recordingLimit: "Limit nagrywania",
  minimumResponseDuration: "Minimalny czas odpowiedzi",
  uploadLimit: "Limit przesylania",
  practiceAllowed: "Dozwolone cwiczenie",
  standardEvaluationRubricInfo:
    "To jest standardowa rubryka oceny, ktora bedzie uzywana do oceny odpowiedzi kandydata na to pytanie.",
  criteria: "Kryteria",
  weightPercentage: "Waga(%)",
  viewRemarks: "Wyświetl uwagi",
  input: "Wejście",
  expectedOutput: "Spodziewane wyjście",
  actualOutput: "Rzeczywiste wyjście",
  untitledSection: "Sekcja bez tytułu",
  testSectionDescription: "Opis sekcji testowej",
  groupAddedSuccessfully: "Grupa dodana pomyślnie",
  addGroupToSection: "Dodaj grupę do sekcji",
  deleteSection: "Usuń sekcję",
  questionPaperDetails: "Szczegóły dokumentu z pytaniami",
  skillsInfoMessage:
    "Wymień kluczowe umiejętności, które ten dokument z pytaniami ma na celu oceniać.",
  contentSettings: "Ustawienia zawartości",
  stakeholderAndReview: "Interesariusze i przegląd",
  statusType: "Typ stanu",
  notReviewed: "Nie zrecenzowano",
  sourceType: "Typ źródła",
  proficiency: "Biegłość",
  beginner: "Początkujący",
  intermediate: "Mediator",
  advanced: "Zaawansowany",
  wecp: "WECP",
  enterMarks: "Wprowadź znaki",
  removeSkill: "Usuń umiejętność",
  searchSkills: "Umiejętności wyszukiwania",
  noSkillsFound: "Nie znaleziono umiejętności.",
  enterTag: "Wprowadź znacznik",
  enterOwner: "Wpisz właściciela",
  enterReviewer: "Wpisz recenzenta",
  noUserWithRole: "Nie znaleziono użytkownika o tej roli",
  createSection: "Utwórz sekcję",
  untitledGroup: "Grupa bez tytułu",
  createGroup: "Utwórz grupę",
  collapseSections: "Zwiń sekcje",
  expandSections: "Rozwiń sekcje",
  assessmentNamePlaceholder: "Proszę wpisać nazwę oceny",
  questionPaperTitleInfo: "Wpisz jasny, opisowy tytuł arkusza pytań.",
  shortDescriptionPlaceholder: "Podaj krótki opis",
  shortDescriptionInfo:
    "Krótkie podsumowanie wyjaśniające, czego dotyczy arkusz pytań.",
  questionPaperInstructionsInfo:
    "Zapisz instrukcje, które kandydaci zobaczą przed rozpoczęciem arkusza pytań. Dołącz ważne szczegóły, takie jak zasady sekcji, formaty pytań, wskazówki nawigacyjne i wytyczne dotyczące przesyłania.",
  questionPaperInstructionsPlaceholder:
    "Zanim rozpoczną ocenę, dodaj wszelkie ważne instrukcje dla uczniów – czas trwania, kryteria zaliczenia, dozwolone narzędzia lub wytyczne.",
  totalMarksAutoCalculatedInfo:
    "Suma punktów zostanie automatycznie obliczona na podstawie liczby pytań wybranych dla każdej grupy. Jeśli liczba wyświetlanych pytań zostanie ustawiona na 0, grupa ta zostanie wykluczona z łącznej liczby ocen.",
  questionPaperType: "Typ papieru pytań",
  questionPaperTypeInfo: "Wybierz format arkusza pytań.",
  durationInfo:
    "Ustaw całkowity limit czasu na wypełnienie arkusza pytań (w minutach).",
  difficultyLevelInfo:
    "Wybierz oczekiwany poziom trudności w oparciu o doświadczenie kandydata.",
  languageInfo: "Wybierz język, w jakim będzie prezentowany arkusz pytań.",
  tagsInfo:
    "Dodaj słowa kluczowe, aby pomóc innym znaleźć ten arkusz pytań za pomocą wyszukiwania.",
  selectCategory: "Wybierz kategorię",
  createLevel: "Tworzyć",
  evaluate: "Oceniać",
  analyze: "Analizować",
  apply: "Stosować",
  understand: "Zrozumieć",
  remember: "Pamiętać",
  allowedCodingLanguagesRequiredInfo:
    "pole jest wymagane tylko w przypadku dodawania pytań dotyczących kodowania do arkusza pytań.",
  knowledgeCategoryInfo:
    "Wybierz poziom umiejętności poznawczych, do którego odnosi się ten arkusz pytań, np. Pamiętaj, Zrozum, Zastosuj.",
  allowedCodingLanguagesInfo:
    "Wybierz języki programowania dozwolone w przypadku pytań dotyczących kodowania w tym arkuszu pytań.",
  expiryDateInfo:
    "Ustaw opcjonalną datę, po której ten arkusz pytań nie powinien być już używany.",
  visibilityInfo: "Wybierz widoczność arkusza pytań",
  visibilityLockedInfo:
    "Po opublikowaniu arkusza pytań w trybie widoczności publicznej wszystkie jego inne wersje również będą widoczne dla publiczności. Podobnie, jeśli zostanie opublikowany jako prywatny, wszystkie wersje pozostaną prywatne.",
  reviewRequired: "Wymagana recenzja",
  reviewRequiredLockedInfo:
    "Ustawienie „Wymagana recenzja” jest zsynchronizowane we wszystkich wersjach arkusza pytań. Jeśli jakakolwiek wersja zostanie opublikowana z włączoną lub wyłączoną opcją sprawdzania, to samo ustawienie będzie miało zastosowanie do wszystkich wersji i nie będzie można ich edytować indywidualnie.",
  reviewRequiredInfo:
    "Włącz, jeśli ten arkusz pytań musi przejść formalny proces przeglądu przed publikacją.",
  savingData: "Zapisywanie danych...",
  questionDataSavedSuccessfully: "Dane pytania zostały zapisane pomyślnie",
  sendQuestionForReviewInstruction:
    "Kliknij przycisk Wyślij do recenzji, aby wysłać go do recenzenta w celu sprawdzenia!",
  publishQuestionInstruction:
    "Kliknij przycisk publikowania, aby opublikować pytanie.",
  noLearningContentAddedAfterSelectingYes:
    "Po wybraniu opcji Tak nie dodano treści edukacyjnych",
  expectedTimeInMinutes: "Oczekiwany czas (w min)",
  codingMarksAutoCalculatedInfo:
    "Te oceny są obliczane automatycznie na podstawie ukrytych przypadków testowych dodanych do tego pytania",
  skillsInfoMessageQuestion:
    "Zapewnij konkretne umiejętności, które uczestnicy nabędą dzięki pytaniu",
  skillsSubtitleQuestion: "Ustaw umiejętności powiązane z tym pytaniem",
  allowedCodingLanguagesInfoQuestion:
    "Wybierz dostępne języki, aby rozwiązać to pytanie",
  selectCodingLanguages: "Wybierz języki kodowania",
  allLanguages: "Wszystkie języki",
  tagsInfoQuestion:
    "Podaj słowa kluczowe, aby kategoryzować, opisywać i identyfikować wydarzenie",
  tagsSubtitleQuestion: "Ustaw tagi dla szybkiego wyszukiwania",
  knowledgeCategorySubtitleQuestion:
    "Pomaga kategoryzować pytania według poziomu umiejętności poznawczych.",
  explanationNotAvailableForSpeakingQuestion:
    "Wyjaśnienie nie jest dostępne w przypadku pytania mówionego",
  ownerVersionSyncInfo:
    "Jeśli zmienimy właściciela tej wersji, zostanie ona również zaktualizowana we wszystkich utworzonych wersjach.",
  ownerInfoMessage: "Wybierz głównych właścicieli pytania",
  ownerReviewerCannotBeSame: "właściciel i recenzent nie mogą być tacy sami",
  reviewerInfoMessage: "Wybierz osobę lub grupę osób jako recenzentów",
  stakeholdersUpdatedSuccessfully:
    "Zainteresowane strony zostały pomyślnie zaktualizowane!",
  unexpectedErrorCreatingNewVersion:
    "Wystąpił nieoczekiwany błąd podczas tworzenia nowej wersji.",
  previewAndPublish: "Wyświetl podgląd i opublikuj",
  viewAnalytics: "Zobacz Analitykę",
  cloneQuestionPrompt: "Czy chcesz sklonować to pytanie?",
  evaluationRubric: "Rubryka oceny",
  problemStatement: "Oświadczenie o problemie",
  problemStatementPlaceholder:
    "Wprowadź opis problemu lub oświadczenie dotyczące quizu",
  addOptionsAndMarkCorrectAnswer: "Dodaj opcje i zaznacz poprawną odpowiedź",
  markCorrectAnswer: "Zaznacz poprawną odpowiedź",
  addCorrectAnswer: "Dodaj poprawną odpowiedź",
  enterCorrectAnswerForBlank:
    "Wpisz poprawną odpowiedź w puste miejsce {{number}}",
  blankWithNumber: "Puste {{number}}",
  addProblemStatementWithBlankToEnableAnswer:
    "Dodaj właściwe określenie problemu ze znakiem „&pustym”, aby umożliwić znalezienie odpowiedzi.",
  enterSolution: "Wprowadź rozwiązanie",
  enterExplanation: "Wprowadź wyjaśnienie",
  codingSolutionExplanationPlaceholder:
    "Krótko wyjaśnij logikę, podejście i przypadki brzegowe obsługiwane w optymalnym rozwiązaniu",
  optionWithNumber: "Opcja {{number}}",
  enterExplanationForAnswer: "Wprowadź wyjaśnienie odpowiedzi {{number}}",
  addOptionToEnableExplanation:
    "Dodaj opcję {{number}}, aby włączyć wyjaśnienie.",
  enterExplanationForBlank: "Wprowadź wyjaśnienie pustego pola {{number}}",
  addProblemStatementWithBlankToEnableExplanation:
    "Dodaj odpowiednie określenie problemu ze znakiem „&pustym”, aby umożliwić wyjaśnienie.",
  enterHint: "Wpisz podpowiedź",
  addUpTo3Hints: "Dodaj maksymalnie 3 wskazówki",
  addMoreOptions: "Dodaj więcej opcji",
  answer: "Odpowiedź",
  exitCodeBlockInfo:
    "Aby wyjść z bloku kodu, przejdź na koniec linii i trzykrotnie kliknij „Enter”.",
  fibBlankInsertionInfo:
    "Aby dodać puste miejsce, zaznacz tekst i kliknij przycisk „Wstaw puste” lub ręcznie dodaj &pusteN, gdzie N może być dowolną liczbą całkowitą, np.: &blank1;",
  htmlEditorAccessInfo:
    "Aby dodać kod lub mieć kontrolę nad formatem, możesz uzyskać dostęp do edytora HTML, klikając ikonę edycji",
  skillSelectionCannotBeEmpty: "Wybór umiejętności nie może być pusty",
  maxDurationInfo:
    "Maksymalny czas, w którym użytkownik może zapisać swoją odpowiedź na to pytanie.",
  minDurationInfo:
    "Minimalny wymagany czas nagrywania, jaki użytkownik musi ukończyć przed przesłaniem odpowiedzi.",
  uploadLimitInfo:
    "Liczba przypadków, w których użytkownik może ponownie zarejestrować swoją odpowiedź przed ostatecznym przesłaniem.",
  textQuestionTitle: "To jest pytanie tekstowe",
  audioRecordQuestionTitle: "To jest pytanie dotyczące nagrania audio",
  audioUploadQuestionTitle: "To jest pytanie dotyczące przesyłania dźwięku",
  videoRecordQuestionTitle: "To jest pytanie dotyczące nagrania wideo",
  videoUploadQuestionTitle: "To jest pytanie dotyczące przesyłania wideo",
  subjectiveQuestionUploadConfigTitle:
    "Subiektywne pytanie Tytuł konfiguracji przesyłania",
  recordingLimitInMinutes: "Limit nagrywania (w min)",
  minimumResponseDurationInMinutes: "Minimalny czas trwania odpowiedzi (w min)",
  recordingLimitLessThanTwenty: "Limit nagrań musi być mniejszy niż 20",
  recordingLimitGreaterThanOrEqualOne:
    "Limit nagrywania musi być większy lub równy 1",
  minimumDurationLessThanRecordingLimit:
    "Minimalny czas odpowiedzi musi być krótszy niż limit nagrywania",
  durationGreaterThanPointFive: "Czas trwania musi być większy niż 0,5",
  uploadLimitGreaterThanZero: "Limit przesyłania musi być większy niż 0",
  addFieldSelectCodingLanguagesInfo:
    "Aby dodać etykietę {{fieldLabel}}, wybierz najpierw dozwolone języki kodowania w sekcji „{{basicDetails}}”.",
  basicDetails: "Podstawowe szczegóły",
  loadingEditor: "Ładowanie edytora...",
  run: "Uruchom",
  writingSolutionInLanguage: "Obecnie piszesz rozwiązanie w",
  changingToLanguageWillClearInput: "Zmiana na",
  unsavedChangesWillBeLostInLanguage: "Twoje niezapisane zmiany w",
  changeLanguage: "Zmień język",
  testCase: "Przypadek testowy",
  add: "Dodać",
  addMinimumVisibleAndHiddenTestCasesInfo:
    "Poniżej dodaj minimum 2 widoczne przypadki testowe i 3 ukryte przypadki testowe",
  visibleToCandidatesForSelfEvaluation: "Widoczne dla kandydatów do samooceny",
  noVisibleTestCasesAddedYet:
    "Nie dodano jeszcze żadnych widocznych przypadków testowych. Kliknij przycisk poniżej, aby go dodać.",
  visibleTestCasesCannotExceedTwenty:
    "Liczba widocznych przypadków testowych nie może przekraczać 20",
  addMoreVisibleTestCases: "Dodaj więcej widocznych przypadków testowych",
  maximumTestCasesLimitReached:
    "Osiągnięto maksymalny limit przypadków testowych",
  hiddenToCandidatesRunsAfterSubmit:
    "Ukryty dla kandydatów, uruchamiany po przesłaniu kandydata",
  noHiddenTestCasesAddedYet:
    "Nie dodano jeszcze żadnych ukrytych przypadków testowych. Kliknij przycisk poniżej, aby go dodać.",
  hiddenTestCasesCannotExceedTen:
    "Ukrytych przypadków testowych nie może być więcej niż 10",
  addMoreHiddenTestCases: "Dodaj więcej ukrytych przypadków testowych",
  hiddenTestCase: "Ukryty przypadek testowy",
  visibleTestCase: "Widoczny przypadek testowy",
  someQuestionsCouldNotBeUpdated:
    "Nie udało się zaktualizować niektórych pytań. Przejrzyj pytania i spróbuj ponownie.",
  publishSummary: "Opublikuj podsumowanie",
  sendForReviewSummary: "Wyślij do podsumowania recenzji",
  moveToDraftSummary: "Przejdź do podsumowania wersji roboczej",
  actionSummary: "Podsumowanie akcji",
  publishSummarySubtitle:
    "Oto podsumowanie Twojej akcji publikowania. Przejrzyj szczegóły poniżej.",
  sendForReviewSummarySubtitle:
    "Oto podsumowanie Twojej prośby o sprawdzenie. Przejrzyj szczegóły poniżej.",
  moveToDraftSummarySubtitle:
    "Oto podsumowanie przejścia do wersji roboczej. Przejrzyj szczegóły poniżej.",
  actionSummarySubtitle:
    "Oto podsumowanie Twoich działań. Przejrzyj szczegóły poniżej.",
  successfully: "Skutecznie",
  failedTo: "Nie udało się",
  moveToDraft: "Przejdź do wersji roboczej",
  details: "Bliższe dane",
  questionTitle: "Tytuł pytania",
  reason: "Powód",
  showLess: "Pokaż mniej",
  showMoreCount: "Pokaż jeszcze {{count}}",
  uploadedAllCountItems: "Przesłano wszystkie {{count}} {{item}}",
  partiallyUploadedCountItems:
    "Częściowo przesłano {{successCount}}/{{totalCount}} {{item}}",
  users: "użytkownicy",
  questions: "pytania",
  viewErrors: "Wyświetl błędy",
  errorsWithFileName: "Błędy - {{fileName}}",
  inputIsRequired: "Dane wejściowe są wymagane",
  expectedOutputIsRequired: "Wymagany jest oczekiwany wynik",
  expectedOutputCannotBeBlank:
    "Oczekiwany wynik nie może być pusty ani zawierać jedynie spacji",
  marksMustBeNumber: "Znaki powinny być liczbą",
  marksAreRequired: "Znaki są wymagane",
  hiddenTestCaseMarksGreaterThanZero:
    "Aby kontynuować, oceny ukrytych przypadków testowych powinny być większe niż 0.",
  hiddenTestCaseMarksMaxThirtyThousand:
    "Oceny za ukryte przypadki testowe nie powinny przekraczać 30 000.",
  explanationMinFiveIfProvided:
    "Jeśli podano wyjaśnienie, musi ono składać się z co najmniej 5 znaków",
  explanationIsRequired: "Wymagane jest wyjaśnienie",
  explanationMinFiveNotBlank:
    "Wyjaśnienie musi składać się z co najmniej 5 znaków, a nie samych spacji",
  provideInput: "Podaj dane wejściowe",
  provideExpectedOutput: "Podaj oczekiwany wynik",
  enterScore: "Wpisz wynik",
  optional: "fakultatywny",
  explainTestCase: "Wyjaśnij przypadek testowy",
  updateTestCase: "Zaktualizuj przypadek testowy",
  addTestCase: "Dodaj przypadek testowy",
  deleteQuestionWithTitlePrompt:
    "Czy na pewno chcesz usunąć to pytanie zatytułowane '{{title}}'?",
  errorFetchingData: "Błąd podczas pobierania danych",
  rowNumber: "Numer wiersza",
  columnName: "Nazwa kolumny",
  useCase: "Przypadek użycia",
  startsAt: "Rozpoczyna się o godz",
  endsAt: "Kończy się o godz",
  invite: "Zapraszać",
  viewReport: "Zobacz raport",
  successfullyDeletedAssessment: "Pomyślnie usunięto ocenę",
  successfullyFreezeActionAssessment: "Pomyślnie {{action}} ocena",
  freezeOperationFailed: "Operacja zamrożenia nie powiodła się",
  deleteAssessmentWithTitlePrompt:
    "Czy na pewno chcesz usunąć tę ocenę zatytułowaną „{{title}}”?",
  freeze: "Zamrażać",
  unfreeze: "Odmrozić",
  freezeAssessmentPrompt: "Czy na pewno chcesz {{action}} tę ocenę?",
  expiresAt: "Wygasa o godz",
  seePreview: "Zobacz Podgląd",
  schedule: "Harmonogram",
  skillBenchmarking: "Benchmarking umiejętności",
  skillBenchmarkingOverview:
    "Przegląd biegłości uczestnika w zakresie określonych umiejętności.",
  proctoringAnalysis: "Analiza Proctoringu",
  proctoringAnalysisOverview:
    "Szybki przegląd aspektów oceny związanych z nadzorem.",
  proctoringStatus: "Stan nadzoru",
  noIrregularitiesReported: "Nie zgłoszono żadnych nieprawidłowości.",
  monitoringOverview: "Przegląd monitorowania",
  complianceNoIncidents:
    "Przestrzeganie zasad oceniania; żadnych incydentów ani oznaczonych zachowań.",
  viewEvidenceClicked: "Kliknięty dowód!",
  marksObtained: "Zdobyte znaki",
  correctAnswer: "Prawidłowa odpowiedź",
  wrongAnswer: "Nieprawidłowa odpowiedź",
  sectionWiseAnalysis: "Sekcja mądra Analiza",
  sectionWiseAnalysisOverview:
    "Przegląd każdego pytania i odpowiedzi kandydata.",
  openAllSections: "Otwórz wszystkie sekcje",
  closeAllSections: "Zamknij wszystkie sekcje",
  sectionWithNumber: "Sekcja {{number}}:",
  score: "Wynik",
  questionAnalysis: "Analiza pytań",
  questionTitleFallback: "Tytuł pytania",
  candidateAnswer: "Odpowiedź kandydata",
  loadAllQuestions: "Załaduj wszystkie {{count}} {{item}}",
  attemptWithNumber: "Próba #{{number}}",
  invalidReportUrl: "Nieprawidłowy adres URL raportu",
  failedToDownloadReportTryAgainLater:
    "Nie udało się pobrać raportu. Spróbuj ponownie później!",
  downloadReport: "Pobierz raport",
  participantName: "Imię i nazwisko uczestnika",
  dateOfAttempt: "Data próby",
  fail: "Ponieść porażkę",
  pass: "Przechodzić",
  userScoredInAssessment: "{{name}} uzyskał {{percentage}} w ocenie.",
  overallSummary: "Ogólne podsumowanie",
  sectionAnalytics: "Sekcja Analityka",
  allAttempts: "Wszystkie próby",
  bestAttempt: "Najlepsza próba",
  latestAttempt: "Ostatnia próba",
  participantList: "Lista uczestników",
  totalParticipantsInvited: "Całkowita liczba zaproszonych uczestników",
  notStarted: "Nie rozpoczęte",
  inProgress: "W toku",
  resultsInProgress: "Wyniki w toku",
  searchByNameOrEmail: "Szukaj według nazwy lub adresu e-mail",
  noUsersAvailableReportCannotBeGenerated:
    "Brak dostępnych użytkowników - nie można wygenerować raportu.",
  userName: "Nazwa użytkownika",
  totalAttempt: "Całkowita próba",
  percentage: "Procent(%)",
  attemptTimeline: "Oś czasu próby",
  noDataFound: "Nie znaleziono danych",
  outOfMarks: "{{obtained}} z {{max}} znaków",
  resultInProcess: "Wynik w procesie",
  participantNotFound: "Nie znaleziono uczestnika!",
  searchedParticipantNotFound: "Nie znaleziono wyszukiwanego uczestnika!",
  noParticipantEnrolled: "Brak zapisanych uczestników!",
  noDataToDisplay: "Brak danych do wyświetlenia",
  participantsPerPage: "Uczestnicy na stronę:",
  actionFailed: "Akcja nie powiodła się",
  failedToRemoveUser: "Nie udało się usunąć użytkownika",
  bestScoreAcrossAttemptsInfo:
    "Wskazuje najlepszy wynik uzyskany w wielu próbach.",
  successfullyRemovedUser: "Pomyślnie usunięto użytkownika",
  successfullyReinvitedUser: "Pomyślnie ponownie zaproszono użytkownika",
  reinviteTooltip:
    "Zaproś ponownie uczestników, którzy jeszcze nie rozpoczęli trwającej oceny",
  reInvite: "Zaproś ponownie",
  noParticipantsInvitedYet: "Żaden uczestnik nie został jeszcze zaproszony",
  scheduleExpired: "Harmonogram wygasł",
  assessmentIsOngoing: "Ocena jest w toku",
  assessmentCompleted: "Ocena ukończona",
  resultNotProcessed: "Wynik nie został przetworzony",
  assessmentNotStarted: "Ocena nie została rozpoczęta",
  remove: "Usunąć",
  confirmReInvitation: "Potwierdź ponowne zaproszenie",
  confirmReinviteMessage:
    "Czy na pewno chcesz ponownie zaprosić uczestników, którzy nie rozpoczęli jeszcze trwającej oceny?",
  removeUserWithNamePrompt: "Czy na pewno chcesz usunąć „{{name}}”?",
  groupType: "Typ grupy",
  objectiveGroupType: "Cel",
  codingGroupType: "Kodowanie",
  subjectiveTextSpeakingGroupType: "Subiektywne (tekst/mówienie)",
  groupTypeImmutableInfo:
    "Typu grupy nie można później zmienić. Można dodawać tylko pytania tego typu.",
  sameMarkGroupingTitle:
    "Pytania można grupować tylko wtedy, gdy mają tę samą wartość ocen",
  sameMarkGroupingDescription:
    "Mieszanie wartości ocen (np. 2 i 5 ocen) w grupie może prowadzić do różnych wyników w sekcjach, jeśli wybranych zostanie tylko kilka pytań. Grupuj pytania dotyczące podobnych ocen, aby zachować spójność wyników.",
  searchQuestion: "Wyszukaj pytanie",
  addAllSelectedQuestions: "Dodaj wszystkie {{count}} wybrane pytania",
  singleQuestionSelectedCount: "Wybrano {{count}} pytanie",
  allQuestionsSelectedCount: "Wybrano wszystkie {{count}} pytania",
  selectedCountOfTotalQuestions: "Wybrano {{selected}} z {{total}} {{label}}",
  addSelectedQuestion: "Dodaj wybrane pytanie",
  validationErrors: "Błędy walidacyjne",
  failedToAddToGroup: "Nie udało się dodać do grupy",
  questionsAddedSuccessfullyWithCount: "{{count}} pytania dodane pomyślnie",
  successfullyUpdatedAssessment: "Pomyślnie zaktualizowano ocenę",
  editCustomTnc: "Edytuj niestandardowy regulamin",
  addCustomTnc: "Dodaj niestandardowy regulamin",
  attributes: "Atrybuty",
  added: "Dodane",
  addAttributes: "Dodaj atrybuty",
  clickHereToAddEditAttributes:
    "Kliknij tutaj, aby dodać lub edytować atrybuty",
  clickHereToAddAttributes: "Kliknij tutaj, aby dodać atrybuty",
  addTncAndSave: "Dodaj regulamin i zapisz",
  savedWithFollowingErrors: "Zapisano z następującymi błędami",
  selectDomain: "Wybierz domenę",
  selectRegion: "Wybierz region",
  selectUsage: "Wybierz zastosowanie",
  selectCategoryFirst: "Najpierw wybierz kategorię",
  selectSubCategory: "Wybierz podkategorię",
  addAttributesAndSave: "Dodaj atrybuty i zapisz",
  questionPaperTimer: "Stoper arkusza pytań",
  sectionLevelTimer: "Stoper na poziomie sekcji",
  questionLevelTimer: "Stoper na poziomie pytania",
  loginWindowDescription:
    "Kandydaci mogą dołączyć tylko w ograniczonym oknie czasowym po godzinie rozpoczęcia.",
  durationBasedDescription:
    "Czas zakończenia jest obliczany automatycznie na podstawie czasu rozpoczęcia + czasu trwania testu.",
  deadlineDescription:
    "Stały czas rozpoczęcia i zakończenia; kandydaci muszą zakończyć przed upływem ostatecznego terminu.",
  loginWindowInfo:
    "Okno logowania to czas (w minutach), w którym kandydaci mogą rozpocząć test po zaplanowanej godzinie rozpoczęcia. Po zamknięciu okna logowania żaden nowy kandydat nie może dołączyć. Okno logowania musi być krótsze lub równe czasowi trwania testu.",
  assessmentDurationInfo:
    "Ustaw tylko czas rozpoczęcia. System automatycznie obliczy czas zakończenia, dodając czas trwania testu.",
  startTimeMinAheadInfo:
    "Czas rozpoczęcia musi być wyznaczony co najmniej 15 minut po aktualnym czasie.",
  loginWindowExample:
    "Przykład: Jeśli czas rozpoczęcia to 9:00, a okno logowania wynosi 30 minut, kandydaci mogą rozpocząć test między 9:00 a 9:30 z dodatkowym 5-minutowym buforem.",
  assessmentDurationExample:
    "Przykład: Jeśli czas rozpoczęcia to 9:00, a czas trwania testu to 60 minut, test zakończy się o 10:00 z dodatkowym 5-minutowym buforem.",
  freeFlow: "Dowolna kolejność",
  oneByOne: "Po kolei",
  subjectiveNoResultInfo: "Subiektywne informacje o statusie 'Brak wyniku'",
  candidateResultVisibility: "Widoczność wyników dla kandydata",
  noResult: "Brak wyniku",
  passPercentageRangeError: "Błąd zakresu procentowego progu zaliczenia",
  attemptsAllowedInfo: "Informacje o dozwolonych próbach",
  maxAttemptsError: "Błąd: Przekroczono maksymalną liczbę prób",
  maximumAttemptsInfo: "Informacje o maksymalnej liczbie prób",
  limitedAttempts: "Ograniczona liczba prób",
  coolOffDescription: "Opis okresu karencji (wyczekiwania)",
  noCoolOffPeriod: "Brak okresu karencji",
  waitFor: "Poczekaj na",
  hours: "Godziny",
  days: "Dni",
  whatLearnersWillSee: "Co zobaczą uczestnicy",
  unlimitedAttemptsInfo: "Masz nieograniczoną liczbę prób dla tego testu.",
  waitBeforeNextAttemptPrefix: "Po każdej próbie musisz odczekać",
  waitBeforeNextAttemptSuffix: "przed rozpoczęciem kolejnej próby.",
  waitBeforeNextAttempt:
    "Po każdej próbie musisz odczekać {duration} przed rozpoczęciem kolejnej próby.",
  singleAttemptInfo: "Masz 1 próbę dostępną dla tej oceny.",
  remainingAttemptsInfoPrefix: "Masz",
  remainingAttemptsInfoMiddle: "z",
  remainingAttemptsInfoSuffix: "prób dostępnych dla tej oceny.",
  remainingAttemptsInfo:
    "Masz {remaining} z {total} prób dostępnych dla tej oceny.",
  enableCertificate: "Włącz certyfikat",
  enableCertificateDescription:
    "Wydaj certyfikat kandydatom po pomyślnym ukończeniu oceny.",
  maxAllowed100: "Maksymalnie dozwolone 100",
  scheduleAssessment: "Zaplanuj ocenę",
  privateAssessmentLabel: "Prywatna ocena",
  publicAssessmentLabel: "Publiczna ocena",
  privateAssessmentDescription:
    "Ta ocena jest dostępna wyłącznie na zaproszenie i tylko w zdefiniowanym oknie czasu rozpoczęcia i zakończenia.",
  publicAssessmentDescription:
    "Ta ocena obsługuje zarówno dostęp samodzielnie przypisany, jak i oparty na zaproszeniu, bez stałego okna dostępu.",
  schedulePublicAssessment: "Zaplanuj publiczną ocenę",
  successfullyPublishedAssessment: "Pomyślnie opublikowano ocenę",
  publishWithoutProctoringPrompt: "Opublikować bez nadzoru (proctoringu)?",
  publishAssessmentPrompt: "Opublikować ocenę?",
  sectionScoreAnalysis: "Analiza wyników sekcji",
  sectionScoreAnalysisOverview: "Przegląd analizy wyników sekcji",
  section: "Sekcja",
  noSectionDataAvailable: "Brak dostępnych danych sekcji",
  difficultyLevelAnalysis: "Analiza poziomu trudności",
  browserViolations: "Naruszenia zasad przeglądarki",
  videoViolations: "Naruszenia wideo",
  times: "Razy",
  statusMessageUnavailable: "Komunikat o statusie niedostępny",
  viewViolationEvidence: "Zobacz dowody naruszenia",
  noBrowserViolationsDetected: "Nie wykryto naruszeń zasad przeglądarki",
  noVideoViolationsDetected: "Nie wykryto naruszeń wideo",
  candidateNotAttemptedCodingMessage:
    "Komunikat: Kandydat nie podjął próby zadania programistycznego",
  candidateCode: "Kod kandydata",
  candidateScore: "Wynik kandydata",
  compilationCount: "Liczba kompilacji",
  submissionCount: "Liczba przesłanych zgłoszeń",
  timeTaken: "Czas trwania",
  testCaseReport: "Raport z przypadków testowych",
  performanceAndCompilationMetrics: "Metryki wydajności i kompilacji",
  totalTestCases: "Łączna liczba przypadków testowych",
  testCasesPassed: "Zaliczone przypadki testowe",
  testCaseDetails: "Szczegóły przypadku testowego",
  searchQuestions: "Szukaj pytań",
  clearSearch: "Wyczyść wyszukiwanie",
  question: "pytanie",
  isSelected: "jest zaznaczone",
  areSelected: "są zaznaczone",
  selected: "Zaznaczone",
  questionsPerPage: "Pytań na stronę:",
  publishQuestions: "Publikuj pytania",
  send: "Wyślij",
  move: "Przenieś",
  publishQuestionsConfirmation:
    "Czy na pewno chcesz opublikować {{count}} {{label}}?",
  sendForReviewConfirmation:
    "Czy na pewno chcesz wysłać {{count}} {{label}} do recenzji?",
  moveToDraftConfirmation:
    "Czy na pewno chcesz przenieść {{count}} {{label}} do wersji roboczych?",
  bulkPublishDisclaimer:
    "Przed opublikowaniem upewnij się, że wszystkie wybrane pytania są kompletne, dokładne i wyświetlają się zgodnie z przeznaczeniem.",
  bulkReviewDisclaimer:
    "Przed wysłaniem do recenzji upewnij się, że wszystkie wybrane pytania są kompletne, dokładne i wyświetlają się zgodnie z przeznaczeniem.",
  bulkDraftDisclaimer:
    "Przed przeniesieniem do wersji roboczych upewnij się, że wszystkie wybrane pytania są kompletne, dokładne i wyświetlają się zgodnie z przeznaczeniem.",
  questionsUnderProcess:
    "Pytania są przetwarzane, kliknij 'wyświetl szczegóły', aby sprawdzić status pytań.",
  mixedStatusesSelected: "Wybrano różne statusy",
  mixedStatusesWarning:
    "Przed kontynuowaniem upewnij się, że wszystkie wybrane pytania mają ten sam status.",
  selectionLimitReached: "Osiągnięto limit wyboru",
  selectionLimitWarning:
    "Nie możesz wybrać więcej niż {{count}} pytań do działania masowego. Odznacz jedno pytanie przed wybraniem kolejnego.",
  knowMore: "Dowiedz się więcej",
  guideLearnersRightDepth:
    "Prowadź swoich uczniów pytaniami o odpowiednim poziomie głębi.",
  bloomCreateDescription:
    "Oceń zdolność ucznia do projektowania, tworzenia architektury lub budowania nowych systemów bądź rozwiązań programistycznych przy użyciu wielu koncepcji.",
  bloomEvaluateDescription:
    "Sprawdź, czy uczeń potrafi krytycznie ocenić kod, uzasadnić wybory lub ewaluować różne rozwiązania.",
  bloomAnalyzeDescription:
    "Przetestuj zdolność ucznia do analizowania kodu, debugowania, śledzenia logiki lub identyfikowania wzorców w systemach technicznych.",
  bloomApplyDescription:
    "Oceń, czy uczeń potrafi zastosować koncepcje do rozwiązywania praktycznych problemów z kodowaniem lub scenariuszy z realnego świata.",
  bloomUnderstandDescription:
    "Sprawdź, czy uczeń potrafi zrozumieć i wyjaśnić pojęcia własnymi słowami lub zinterpretować działanie programu.",
  bloomRememberDescription:
    "Oceń zdolność ucznia do przywoływania podstawowych definicji, składni i informacji o faktach.",
  bloomVerbCreate: "Utwórz",
  bloomVerbDesign: "Zaprojektuj",
  bloomVerbConstruct: "Skonstruuj",
  bloomVerbDevelop: "Opracuj",
  bloomVerbEvaluate: "Oceń",
  bloomVerbJustify: "Uzasadnij",
  bloomVerbDefend: "Broń",
  bloomVerbAssess: "Oszacuj",
  bloomVerbAnalyze: "Przeanalizuj",
  bloomVerbDifferentiate: "Różnicuj",
  bloomVerbOrganize: "Uporządkuj",
  bloomVerbCompare: "Porównaj",
  bloomVerbApply: "Zastosuj",
  bloomVerbUse: "Użyj",
  bloomVerbDemonstrate: "Zaprezentuj",
  bloomVerbSolve: "Rozwiąż",
  bloomVerbExplain: "Wyjaśnij",
  bloomVerbDescribe: "Opisz",
  bloomVerbSummarize: "Streszcz",
  bloomVerbInterpret: "Zinterpretuj",
  bloomVerbList: "Wymień",
  bloomVerbDefine: "Zdefiniuj",
  bloomVerbName: "Nazwij",
  bloomVerbRecall: "Przypomnij sobie",
  bloomVerbRecognize: "Rozpoznaj",
  bloomCreateExample1:
    "Utwórz aplikację jednostronicową (SPA) przy użyciu React i Redux.",
  bloomCreateExample2:
    "Zaprojektuj schemat bazy danych dla aplikacji typu Uber (ride-sharing).",
  bloomCreateExample3: "Opracuj potok CI/CD przy użyciu GitHub Actions.",
  bloomEvaluateExample1:
    "Oceń plusy i minusy stosowania NoSQL w porównaniu do SQL w architekturze mikrousług.",
  bloomEvaluateExample2:
    "Rekomenduj ulepszenia w celu optymalizacji wydajności komponentu React.",
  bloomAnalyzeExample1:
    "Porównaj wydajność sortowania przez scalanie (merge sort) i sortowania szybkiego (quicksort).",
  bloomAnalyzeExample2:
    "Przeanalizuj zużycie pamięci tej funkcji rekurencyjnej.",
  bloomAnalyzeExample3: "Sklasyfikuj błędy w tym bloku kodu JavaScript.",
  bloomApplyExample1:
    "Zastosuj algorytm wyszukiwania binarnego, aby znaleźć element w tablicy.",
  bloomApplyExample2: "Użyj pętli, aby wypisać ciąg Fibonacciego w Pythonie.",
  bloomApplyExample3:
    "Rozwiąż realny problem przy użyciu mapy mieszającej (hash map).",
  bloomUnderstandExample1:
    "Wyjaśnij, jak działa stos, opierając się na zasadzie LIFO.",
  bloomUnderstandExample2:
    "Opisz różnicę między var, let i const w JavaScript.",
  bloomUnderstandExample3: "Zinterpretuj wynik podanego zapytania SQL.",
  bloomRememberExample1:
    "Zidentyfikuj poprawny znacznik HTML do utworzenia hiperłącza.",
  bloomRememberExample2:
    "Nazwij cztery filary programowania obiektowego (OOP).",
  bloomRememberExample3: "Wymień proste (prymitywne) typy danych w Javie.",
  commonVerbs: "Typowe czasowniki",
  exampleQuestions: "Przykładowe pytania",
  noExamplesAvailable: "Brak dostępnych przykładów.",
  candidateResponse: "Odpowiedź kandydata",
  correctQuestions: "Poprawne pytania",
  totalQuestions: "Łączna liczba pytań",
  correctQuestionPercentage: "Procent poprawnych pytań",
  performance: "Wynik",
  level: "POZIOM",
  noOfQuestions: "LICZBA PYTAŃ",
  correctAttempts: "POPRAWNE PRÓBY",
  correctness: "POPRAWNOŚĆ",
  partiallyCorrect: "CZEŚCIOWO POPRAWNE",
  partiallyCorrectPercentage: "PROCENT CZĘŚCIOWO POPRAWNYCH",
  rescheduleAssessmentPrompt:
    "Potwierdź, czy chcesz zmienić termin testu o nazwie „{{title}}”",
  assessmentAlreadyStarted: "Test już się rozpoczął",
  readMore: "Czytaj więcej",
  best: "Najlepsze",
  latest: "Najnowsze",
  allQuestions: "Wszystkie pytania",
  myQuestions: "Moje pytania",
  publicQuestions: "Publiczne pytania",
  remarks: "Uwagi",
  addRemarks: "Dodaj uwagi",
  noGroupsAdded: "Nie dodano jeszcze żadnych grup",
  addGroupInfo:
    "Zacznij od utworzenia grupy, aby móc dodawać pytania. Kliknij przycisk „Dodaj grupę do sekcji” poniżej, aby rozpocząć.",
  exitPreview: "Zakończ podgląd",
  preview: "Podgląd",
  problemStatementNotAdded: "Opis problemu nie został dodany",
  durationDayUnit: "dzień",
  durationDaysUnit: "dni",
  durationHourUnit: "godz.",
  durationHoursUnit: "godz.",
  durationMinuteUnit: "min",
  customFieldAddedForSingleLanguage:
    "Niestandardowe pole {{fieldLabel}} dodane dla {{current}} z {{total}} języka",
  customFieldAddedForMultipleLanguages:
    "Niestandardowe pole {{fieldLabel}} dodane dla {{current}} z {{total}} języków",
  email: "E-Mail",
  tagInputHint: "Dodaj oddzielone przecinkami",
  enterOptions: "Wprowadź opcje",
  groupNotFound: "Nie znaleziono grupy",
  sheetNotFound: "Nie znaleziono arkusza",
  missingHeaders: "Brakuje wymaganych nagłówków",
  assetNotFound: "Nie znaleziono zasobu",
  noValidDataFound: "Nie znaleziono poprawnych danych",
  notFoundPID: "Nie znaleziono uczestnika.",
  invalidParticipants: "Nieprawidłowy uczestnik.",
  alreadyAdded: "Uczestnik został już dodany.",
  duplicateData: "Znaleziono duplikat danych.",
  invalidData: "Nieprawidłowe dane.",
  warnings: "Ostrzeżenia",
  assignedToMyself: "Przydzielone do mnie (Samodzielna nauka)",
  assignedByMe: "Przydzielone przeze mnie (Moje Zadania)",
  urlCopiedToClipboard: "URL skopiowany do schowka!",
  failedToCopyUrl: "Nie udało się skopiować adresu URL.",
  content: "Treść",
  platformHelp: "Pomoc platformy",
  privacyPolicy: "Polityka prywatności",
  logout: "Wyloguj",
  logoutConfirmTitle: "Czy na pewno chcesz się wylogować?",
  logoutConfirmDescription:
    "Wychodzisz? Zawsze możesz wrócić i kontynuować od miejsca, w którym skończyłeś.",
  stayEngaged: "Pozostań zaangażowany"
} as const;
export default pl;
